import backedUpDefinition from './backed-up.js';
import lockedDefinition from './locked.js';
const selectorDefinitions = [lockedDefinition, backedUpDefinition];
export default selectorDefinitions;
